import React from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { Profile } from '@/types/auth';
import { BentoWidget } from './widgets/BentoWidget';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const ResponsiveGridLayout = WidthProvider(Responsive);

interface BentoGridProps {
  profile: Profile;
  layout: any[];
  isEditMode: boolean;
  onLayoutChange: (layout: any[]) => void;
}

export const BentoGrid: React.FC<BentoGridProps> = ({
  profile,
  layout,
  isEditMode,
  onLayoutChange,
}) => {
  const breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
  const cols = { lg: 6, md: 4, sm: 3, xs: 2, xxs: 1 };

  return (
    <div className={`w-full max-w-6xl mx-auto ${isEditMode ? 'edit-mode-grid' : ''}`}>
      <ResponsiveGridLayout
        className="layout"
        layouts={{ lg: layout }}
        breakpoints={breakpoints}
        cols={cols}
        rowHeight={120}
        margin={[16, 16]}
        isDraggable={isEditMode}
        isResizable={isEditMode}
        onLayoutChange={(layout) => onLayoutChange(layout)}
        draggableHandle=".drag-handle"
        resizeHandles={['se']}
      >
        {layout.map((item) => (
          <div
            key={item.i}
            className={`
              relative rounded-xl border bg-card text-card-foreground shadow-sm overflow-hidden
              ${isEditMode ? 'ring-2 ring-primary/20 hover:ring-primary/40' : ''}
              transition-all duration-200
            `}
            style={{ zIndex: 1 }}
          >
            {isEditMode && (
              <div className="drag-handle absolute top-2 left-2 z-50 w-6 h-6 bg-primary/20 rounded cursor-move hover:bg-primary/40 transition-colors"
                   style={{ zIndex: 50 }}>
                <div className="w-full h-full flex items-center justify-center">
                  <div className="w-3 h-3 grid grid-cols-2 gap-0.5">
                    {[...Array(4)].map((_, i) => (
                      <div key={i} className="w-1 h-1 bg-primary rounded-full" />
                    ))}
                  </div>
                </div>
              </div>
            )}
            
            <BentoWidget
              widgetId={item.i}
              profile={profile}
              isEditMode={isEditMode}
            />
          </div>
        ))}
      </ResponsiveGridLayout>
    </div>
  );
};